import { React, useState, useEffect } from "react";
import "./Sidebar.css";
import { useGlobalContext } from "../context";
import { BiArrowBack } from "react-icons/bi";
import { FaChessBoard, FaMicroscope } from "react-icons/fa";
import {
  MdCheckBoxOutlineBlank,
  MdCheckBox,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdSwapVert,
} from "react-icons/md";

const Sidebar = () => {
  const {
    showSidebar,
    setShowSidebar,
    showNotation,
    setShowNotation,
    chessboardColor,
    setChessboardColor,
    boardOrientation,
    setBoardOrientation,
    showEvaluationBar,
    setShowEvaluationBar,
    showStockfishEvaluation,
    setShowStockfishEvaluation,
    setStockfishDepth,
    stockfishDepth,
    showMaterialInfo,
    setShowMaterialInfo,
    stockfishVersion,
    lozzaDepth,
    setLozzaDepth,
    showLozzaEvaluation,
    setShowLozzaEvaluation,
    showVariants,
    setShowVariants,
  } = useGlobalContext();

  const [showBoardSettings, setShowBoardSettings] = useState(true);
  const [showChessboardColorOptions, setShowChessboardColorOptions] =
    useState(false);

  // Save variables in local storage (remember user's choices)
  useEffect(() => {
    localStorage.setItem("showNotation", showNotation);
  }, [showNotation]);

  useEffect(() => {
    localStorage.setItem("chessboardColor", JSON.stringify(chessboardColor));
  }, [chessboardColor]);

  useEffect(() => {
    localStorage.setItem(
      "showEvaluationBar",
      JSON.stringify(showEvaluationBar)
    );
  }, [showEvaluationBar]);

  return (
    <div
      className={`${
        showSidebar ? "sidebar-container show-sidebar" : "sidebar-container"
      }`}
    >
      {/* Header */}
      <div className="sidebar-header">
        <h3>Ustawienia</h3>
        <BiArrowBack
          className="sidebar-close-btn"
          onClick={() => {
            setShowSidebar(false);
            setShowChessboardColorOptions(false);
          }}
        />
      </div>
      {/* Settings types */}
      <div className="sidebar-btns-container">
        <button
          className="sidebar-btn"
          onClick={() => setShowBoardSettings(true)}
        >
          <FaChessBoard />
          <p>ustawienia szachownicy</p>
        </button>
        <button
          className="sidebar-btn"
          onClick={() => setShowBoardSettings(false)}
        >
          <FaMicroscope />
          <p>ustawienia analizy</p>
        </button>
      </div>
      {/* Chessboard settings */}
      <div
        className="chessboard-settings"
        style={!showBoardSettings ? { display: "none" } : {}}
      >
        {/* Show / hide chessboard notation */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowNotation(!showNotation);
          }}
        >
          <h4>notacja</h4>
          {showNotation ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
        </div>
        <div
          className="settings-item settings-btn"
          onClick={() => {
            boardOrientation === "white"
              ? setBoardOrientation("black")
              : setBoardOrientation("white");
          }}
        >
          <h4>Orientacja szachownicy</h4>
          <MdSwapVert />
        </div>
        {/* Choose chessboard color */}
        <div
          className="settings-item settings-btn"
          onClick={() =>
            setShowChessboardColorOptions(!showChessboardColorOptions)
          }
        >
          <h4>kolor szachownicy</h4>
          {!showChessboardColorOptions ? (
            <MdKeyboardArrowDown />
          ) : (
            <MdKeyboardArrowUp />
          )}
        </div>
        {showChessboardColorOptions ? (
          <div className="chessboard-color-options">
            <button
              className="chessboard-color color1"
              onClick={() => setChessboardColor("color-black")}
            ></button>
            <button
              className="chessboard-color color2"
              onClick={() => setChessboardColor("color-brown")}
            ></button>
            <button
              className="chessboard-color color3"
              onClick={() => setChessboardColor("color-gray")}
            ></button>
          </div>
        ) : (
          <></>
        )}
      </div>
      {/* Analysis settings */}
      <div
        className="analysis-settings"
        style={showBoardSettings ? { display: "none" } : {}}
      >
        {/* Show / hide evaluation bar */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowEvaluationBar(!showEvaluationBar);
          }}
        >
          <h4>pasek ewaluacji</h4>
          {showEvaluationBar ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
        </div>
        {/* Show / hide variants */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowVariants(!showVariants);
          }}
        >
          <h4>warianty</h4>
          {showVariants ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
        </div>
        {/* Show / hide material info */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowMaterialInfo(!showMaterialInfo);
          }}
        >
          <h4>Wyjaśnianie pozycji</h4>
          {showMaterialInfo ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
        </div>
        {/* Show / hide Stockfish evaluation */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowStockfishEvaluation(!showStockfishEvaluation);
          }}
        >
          <h4>Ewaluacja (Stockfish {stockfishVersion})</h4>
          {showStockfishEvaluation ? (
            <MdCheckBox />
          ) : (
            <MdCheckBoxOutlineBlank />
          )}
        </div>
        {/* Show / hide Lozza evaluation */}
        <div
          className="settings-item settings-btn"
          onClick={() => {
            setShowLozzaEvaluation(!showLozzaEvaluation);
          }}
        >
          <h4>Ewaluacja (Lozza)</h4>
          {showLozzaEvaluation ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
        </div>
        {/* Set Stockfish depth */}
        <div className="settings-item">
          <h4>Głębia analizy (Stockfish {stockfishVersion})</h4>
          <select
            className="choose-stockfish-depth"
            onChange={(e) => setStockfishDepth(e.target.value)}
            defaultValue={stockfishDepth}
          >
            <option value="10">10</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
            <option value="16">18</option>
            <option value="22">22</option>
          </select>
        </div>
        {/* Set Stockfish depth */}
        <div className="settings-item">
          <h4>Głębia analizy (Lozza)</h4>
          <select
            className="choose-stockfish-depth"
            onChange={(e) => setLozzaDepth(e.target.value)}
            defaultValue={lozzaDepth}
          >
            <option value="10">10</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
